var map = {
	"./baby.svg": "1555",
	"./camera.svg": "8ce0",
	"./classification.svg": "83cc",
	"./file.svg": "b8b2",
	"./img.svg": "9036",
	"./jianpan.svg": "626d",
	"./location.svg": "1c50",
	"./phone.svg": "dd82",
	"./send-button.svg": "b755",
	"./service.svg": "4e04",
	"./video.svg": "8f2b",
	"./yuyin.svg": "184e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";